<template>
	<div>
		<div class="totalPie">
			<div class="tit">
				<p>淤地坝基础信息</p>
			</div>
     <div class="baseinfo">
        <img src="../../common/images/baming.png" class="qdimg"/>
        <p class="basetext">{{ydbName}}</p>
        <p class="basetext1">{{baseinfoData.type}}</p>
      </div>
      <div class="baseinfo1">
        <img src="../../common/images/position.png" class="qdimg1"/>
        <p class="basetext2">位置：</p>
        <p class="basetext3">{{position}}</p>
      </div>
      <div class="baseinfo">
         <img src="../../common/images/bagao.png" class="qdimg"/>
         <p class="basetext4">坝高：</p>
         <p class="basetext5">{{bagao}}</p>
         <div style="float: right;">
           <img src="../../common/images/kurong.png" class="qdimg"/>
           <p class="basetext4">库容：</p>
           <p class="basetext5">{{kurong}}</p>
         </div>
       </div>
       <div class="baseinfo1">
         <img src="../../common/images/gongn.png" class="qdimg1"/>
         <p class="basetext2">功能：</p>
         <p class="basetext3">{{baseinfoData.func}}</p>
       </div>
		</div>
		<div class="zrrlist">
      <div class="tit">
      	<p>各级责任人清单</p>
      </div>
      <ul>
      	<li v-for="(item,i) in qdlist" :key="i">
      		<img src="../../common/images/fxxzfzr.png" class="qdimg" v-if="item.code==1" />
      		<img src="../../common/images/fxjsfzr.png" class="qdimg" v-if="item.code==2" />
      		<img src="../../common/images/fxxc.png" class="qdimg" v-if="item.code==3" />
      		<img src="../../common/images/skbm.png" class="qdimg" v-if="item.code==4" />
      		<img src="../../common/images/skgl.png" class="qdimg" v-if="item.code==5" />
      		<div class="qdtext">
      			<p>{{item.textl}}</p>
      			<p>
      				<span>{{item.name}}</span>
      				<span></span>
      				<span>{{item.tel}}</span>
      			</p>
      		</div>
      	</li>
      </ul>
		</div>
	</div>
</template>

<script>
  import { ydbjbxxQuery } from '@/api/api.js'
	export default{
    props:['gisclick'],
		data(){
			return{
        ydbName: '',
        bagao: '',
        kurong: '',
        position: '',
        baseinfoData: {
          name: "",
          type: "",
          place: "",
          bheight: '',
          kurong: '',
          func: ""
        },
        qdlist: [],
			}
		},
		methods:{
      ydbListFun(params) {
        let _this = this;
        ydbjbxxQuery(params).then((res) => {
          _this.ydbName = res.data[0].ydbName;
          _this.bagao = res.data[0].ydbBaGao;
          _this.kurong = res.data[0].ydbYykr;
          _this.position = res.data[0].ydbSheng+res.data[0].ydbShi+res.data[0].ydbXian+res.data[0].ydbSszl;
        })
      },
		},
    watch:{
    	gisclick(a){
        if (a.ydbCode) {
          let params = {ydbCode:a.ydbCode};
          this.ydbListFun(params);
        } else{
          this.ydbName = a.NAME;
          this.bagao = a.BAGAO;
          this.kurong = a.YKURONG;
          this.position = a.SHENG+a.SHI+a.XIAN+a.ZHILIU;
        }
    	}
    },
		mounted(){

		}
	}
</script>

<style scoped>
	.totalPie,.zrrlist{
		width: 100%;
		height: 340px;
		background: url(../../common/images/contentborder.png) no-repeat center;
		background-size:100% 100%;
    overflow: hidden;
	}

  .zrrlist {
    margin-top:15px;
  }

  .tit {
    padding-bottom: 5px;
    border-bottom: 1px solid #098dc7;
  }

  .zrrlist ul li {
  	width: 90%;
    margin-left: 5%;
  	height: 45px;
  	border-bottom: 1px dotted #54555c;
  	cursor: pointer;
  }

  .baseinfo {
  	width: 90%;
    margin-left: 5%;
  	height: 45px;
  	border-bottom: 1px dotted #54555c;
  	cursor: pointer;
  }

  .baseinfo1 {
  	width: 90%;
    margin-left: 5%;
  	height: 60px;
  	border-bottom: 1px dotted #54555c;
  	cursor: pointer;
  }

  .basetext {
    float: left;
    height: 45px;
    margin-left: 10px;
    color: #fff;
    font-size: 16px;
    line-height: 45px;
  }

  .basetext1 {
    float: left;
    height: 21px;
    width: 50px;
    text-align: center;
    line-height: 21px;
    font-size: 12px;
    margin-top: 12px;
    margin-left: 10px;
    color: #00b3fe;
    border: 1px solid #00b3fe;
    border-radius: 30%;
    background-color: rgba(48, 144, 198, 0.3);
  }

  .basetext2 {
    float: left;
    height: 30px;
    margin-left: 10px;
    color: #00b3fe;
    font-size: 14px;
    line-height: 30px;
  }

  .basetext3 {
    float: left;
    height: 30px;
    width: 230px;
    margin-left: 10px;
    color: #b8bdcb;
    font-size: 14px;
    line-height: 30px;
  }

  .basetext4 {
    float: left;
    height: 45px;
    margin-left: 10px;
    color: #00b3fe;
    font-size: 14px;
    line-height: 45px;
  }

  .basetext5 {
    float: left;
    height: 45px;
    margin-left: 10px;
    color: #b8bdcb;
    font-size: 14px;
    line-height: 45px;
  }

  .qdimg1 {
  	width: 20px;
  	height: 20px;
  	float: left;
  	margin-top: 5px;
  	margin-left: 10px;
  }

  .qdimg {
  	width: 20px;
  	height: 20px;
  	float: left;
  	margin-top: 11px;
  	margin-left: 10px;
  }

  .qdtext {
  	width: calc(100% - 44px);
  	width: -webkit-calc(100% - 44px);
  	width: -moz-calc(100% - 44px);
  	float: right;
  	height: 45px;
  	margin-left: 10px;
  }

  .qdtext p:nth-child(1) {
  	color: #00b3fe;
  	font-size: 12px;
  	width: 1005;
  	line-height: 12px;
  	margin-top: 7px;
  }

  .qdtext p:nth-child(2) {
  	color: #fdfdfd;
  	font-size: 12px;
  	width: 1005;
  	line-height: 12px;
  	margin-top: 5px;
  }

  .qdtext p:nth-child(2) span:nth-child(1) {
  	margin-right: 8px;
  	border-right: 1px solid #fdfdfd;
  	padding-right: 8px;
  	font-size: 12px;
  	display: block;
  	float: left;
  	height: 12px;
  }

  .qdtext p:nth-child(2) span:nth-child(2) {
  	display: block;
  	width: 12px;
  	height: 12px;
  	background: url(../../common/images/tel.png) no-repeat center;
  	background-size: 100% 100%;
  	float: left;
  	margin-right: 6px;
  }
</style>
